RivalIQ.apps.Shell.module('collections', function (collections, App, Backbone, Marionette, $, _) {

    'use strict';

    collections.ToolbarItems = Backbone.Collection.extend({
        model: function (attrs) {
            return new Backbone.Model(attrs);
        }
    });
});
